import { Button } from "@relevoo/ui/web";

const GenericErrorPage: React.FC = () => (
	<main className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-background px-4 text-center">
		<h1 className="text-2xl font-bold text-foreground">Une erreur est survenue</h1>
		<p className="max-w-md text-sm text-muted">Nous sommes désolés, quelque chose s'est mal passé. Essayez de recharger la page.</p>
		<Button onPress={() => window.location.reload()}>Recharger la page</Button>
	</main>
);

export default GenericErrorPage;
